import { Box, Typography, useTheme } from '@mui/material';

const InsurancePurchaseStep = ({ logoUrl: Icon, title, text }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        textAlign: 'center',
      }}
    >
      {/* Ícone */}
      <Box
        sx={{
          backgroundColor: `${theme.palette.grey[50]}`,
          padding: theme.spacing(1),
          borderRadius: '10px',
          width: '44px',
          height: '44px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Icon
          style={{
            width: '80%',
            height: '80%',
            color: theme.palette.primary.main,
          }}
        />
      </Box>

      {/* Título */}
      <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
        {title}
      </Typography>

      {/* Texto */}
      <Typography
        variant="body2"
        sx={{ color: theme.palette.text.secondary, textAlign: 'left' }}
      >
        {text}
      </Typography>
    </Box>
  );
};

export default InsurancePurchaseStep;
